<div class="shoppingList-wrapper" *ngIf="isOpen">
	<div class="shoppingList">
		<h1 class="heading--withChild" i18n="@@shoppingList-heading" *cdxEmbedded="'hide'">
			<cdx-svg-icon name="shopping-list" fill="dark"></cdx-svg-icon>Shopping List<a
				[routerLink]="shoppingListPage"
				cdxButton
				class="shoppingList-headingEdit"
				fillStyle="flat"
				size="small"
				[inline]="true"
				>Edit all</a
			>
		</h1>

		<ng-container *ngIf="!isInEditMode">
			<button
				class="shoppingList-dirBtn shoppingList-dirBtn--prev"
				aria-label="previous"
				(click)="prevClick()"
				*ngIf="showPrevBtn"
			>
				<cdx-svg-icon size="small" name="chevron-left"></cdx-svg-icon>
			</button>
			<button
				class="shoppingList-dirBtn shoppingList-dirBtn--next"
				aria-label="next"
				(click)="nextClick()"
				*ngIf="showNextBtn"
			>
				<cdx-svg-icon size="small" name="chevron-right"></cdx-svg-icon>
			</button>
		</ng-container>

		<section
			class="shoppingList-track"
			attr.aria-labelledby="shoppingList-toggleBtn"
			id="shoppingList"
			role="region"
			[attr.aria-expanded]="isOpen"
			[ngClass]="{ 'shoppingList--noOverflow': isInEditMode }"
			#shoppingListElement
		>
			<ng-container *ngIf="shoppingListItems?.length; else noItemsContent">
				<ul #listItems class="shoppingList-items" [style.display]="isInEditMode ? 'none' : 'block'">
					<li *ngFor="let item of shoppingListItems; let i = index; let isFirst = first">
						<button
							#shoppingListItem
							endSlotSize="small"
							[endSlotActive]="canEdit(i)"
							[fillStyle]="getButtonFillStyle(i)"
							(click)="handleShoppingListItemClick(i)"
							cdxButton
							[attr.formAutoFocus]="isFirst"
						>
							<span class="sr-only" *ngIf="!canEdit(i)">Search for</span> {{ item }}
							<ng-container end *ngIf="canEdit(i)">
								<span class="sr-only">Press enter to edit this item</span>
								<cdx-svg-icon size="small" name="edit"></cdx-svg-icon>
							</ng-container>
						</button>
					</li>
					<li class="shoppingList-item--checkout">
						<a routerLink="/shop/checkout" cdxButton fillStyle="primary">Checkout</a>
					</li>
				</ul>

				<div class="shoppingList-itemEdit" *ngIf="isInEditMode">
					<button
						fillStyle="flat"
						cdxButton
						aria-label="Back to shopping list"
						class="shoppingList-backToListBtn"
						(click)="backToItemList()"
						type="button"
					>
						<cdx-svg-icon name="chevron-left" size="extra-small" fill="dark"></cdx-svg-icon>
					</button>
					<cdx-button-group [formGroup]="shoppingListEditForm">
						<form-input
							#editInput
							formControlName="itemName"
							id="itemName"
							[selectOnClick]="true"
							(keyup)="inputKeyup($event)"
							formAutoFocus
						>
							<label class="sr-only" i18n="@@shoppingList-edit" for="itemName" label>Edit shopping list item</label>
						</form-input>
						<button
							cdxButton
							type="button"
							(click)="updateItem()"
							i18n="@@shoppingList-doneButton"
							aria-label="Submit the edited shopping list item"
						>
							Update
						</button>
					</cdx-button-group>
					<button
						class="shoppingList-deleteItemBtn"
						type="button"
						size="small"
						[startSlotActive]="true"
						startSlotSize="small"
						fillStyle="tertiaryFlat"
						(click)="deleteItem()"
						cdxButton
						aria-label="Delete item from shopping list"
					>
						<cdx-svg-icon name="trash" size="small" fill="dark" start></cdx-svg-icon
						><span class="hidden-phone">Delete</span>
					</button>
				</div>
			</ng-container>
			<ng-template #elseTemplate> </ng-template>

			<ng-template #noItemsContent>
				<div class="shoppingList-noItems">
					<p aria-label="Save time and search for a list of items">
						<span class="visible-phone">Search for a list</span>
						<span class="hidden-phone">Save time and search for a list of items</span>
					</p>
					<a
						[inline]="true"
						class="shoppingList-addBtn"
						[routerLink]="shoppingListPage"
						cdxButton
						size="small"
						fillStyle="outline"
						[startSlotActive]="true"
						startSlotSize="small"
					>
						<cdx-svg-icon name="plus" size="small" fill="green" start></cdx-svg-icon>{{ noItemsButtonText }}
					</a>
				</div>
			</ng-template>
			<div></div>
		</section>
	</div>
</div>
